import { useState } from 'react';
import { resolveImagePath } from '@/utils/imageResolver';

interface NavigationItem {
  id: string;
  label: string;
  href: string;
  external?: boolean;
}

const mainNavigation: NavigationItem[] = [
  { id: 'home', label: 'Home', href: '/' },
  { id: 'contact', label: 'Contact', href: '/contact' },
  { id: 'fbo', label: 'FBO', href: 'http://centricaviation.com', external: true },
];

const mobileNavigation: NavigationItem[] = [
  { id: 'contact', label: 'Contact', href: '/contact' },
  { id: 'fbo', label: 'FBO', href: '/fbo' },
  { id: 'charter', label: 'Charter', href: '/charter' },
  { id: 'rental-cars', label: 'Rental Cars', href: 'https://centriccar.com/', external: true },
  { id: 'call', label: 'Call (850) 745-0422', href: 'tel:8507450422' },
];

export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center">
              <img
                src={resolveImagePath('/images/centric-mx-logo.png')}
                alt="Centric Logo"
                title="centric-mx-logo"
                className="h-12 w-auto"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {mainNavigation.map((item) => (
              <a
                key={item.id}
                href={item.href}
                className="text-gray-700 hover:text-blue-600 font-medium transition-colors"
                {...(item.external && { target: '_blank', rel: 'noopener noreferrer' })}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Phone Number Button */}
          <div className="hidden md:flex">
            <a
              href="tel:8507450422"
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md font-medium transition-colors"
            >
              850-745-0422
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="text-gray-700 hover:text-blue-600 p-2"
              aria-label="Toggle mobile menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {isMobileMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-gray-200">
            <nav className="py-2 space-y-1">
              {mobileNavigation.map((item) => (
                <a
                  key={item.id}
                  href={item.href}
                  className="block px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 font-medium transition-colors"
                  {...(item.external && { target: '_blank', rel: 'noopener noreferrer' })}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}